import { registerQuery } from 'data-fetching-client';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_DISPLAY_NAME = registerQuery({
  fieldName: 'displayName',
  fetcher: () => ecosystemAppClient.get(`/reviews/display-names`)
});